import React, {useEffect, useRef, useState} from "react";
import * as Sentry from '@sentry/browser';
import PropTypes from "prop-types";
import MaskedInput from "react-text-mask";
import {FormattedMessage} from "react-intl";
var generator = {
    generate: function (opts) {
        var length = (opts && opts.length) || 10;
        var chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        if (opts && opts.numbers) chars += "0123456789";
        if (opts && opts.symbols) chars += "!@#$%^&*()_+-=";
        var result = "";
        var array = new Uint32Array(length);
        window.crypto.getRandomValues(array);
        for (var i = 0; i < length; i++) {
            result += chars[array[i] % chars.length];
        }
        return result;
    }
};
import useDebounce from "../../../hoc/UseDebounce";
import Icon from "../Icon";

import classes from "./styles.module.css";

const InputHelper = ({
                         index,
                         onChange,
                         value,
                         placeholder,
                         fieldName,
                         label,
                         isDisabled,
                         changeRegexp,
                         blurRegexp,
                         isUppercase,
                         changeMessage,
                         blurMessage,
                         autoComplete,
                         readonly,
                         isRequired
                     }) => {

    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    function handlerChange(name, value) {

        if (changeRegexp && value.match(changeRegexp)) {

            setIsValid(false);

            setErrorMessage(() => {
                return <FormattedMessage id={changeMessage} defaultMessage="no translate"/>
            })

        } else {
            setIsValid(true);

            if (isUppercase)
                onChange(name, value.toUpperCase());
            else
                onChange(name, value);

        }
    }

    function handlerChangeWithIndex(index, name, value) {

        if (changeRegexp && value.match(changeRegexp)) {

            setIsValid(false);

            setErrorMessage(() => {
                return <FormattedMessage id={changeMessage} defaultMessage="no translate"/>
            })

        } else {
            setIsValid(true);

            if (isUppercase)
                onChange(index, name, value.toUpperCase());
            else
                onChange(index, name, value);

        }
    }

    function handlerBlur(name, value) {
        if (isRequired && value.length === 0) {
            setIsValid(false);
            if (blurMessage) {
                setErrorMessage(() => {
                    return <FormattedMessage id={blurMessage} defaultMessage="no translate"/>
                })
            }
        } else if (blurRegexp && !value.match(blurRegexp)) {
            setIsValid(false);
            if (blurMessage) {
                setErrorMessage(() => {
                    return <FormattedMessage id={blurMessage} defaultMessage="no translate"/>
                })
            }
        } else {
            setIsValid(true);
        }
    }

    return (
        <div className={classes.Wrap}>

            <label className={classes.Label}><FormattedMessage id={label} defaultMessage="no translation"/></label>

            <input placeholder={placeholder}
                   className={`${classes.Input} ${fieldName === 'cardHolder' ? classes.Uppercase : ''}`}
                   value={value}
                   onChange={(e) => index != null ?
                       handlerChangeWithIndex(index, fieldName, e.target.value)
                       : handlerChange(fieldName, e.target.value)}
                   onBlur={(e) => handlerBlur(fieldName, e.target.value)}
                   disabled={isDisabled}
                   autoComplete={autoComplete ? autoComplete : "on"}
                   readOnly={readonly}
            />
            {!isValid && <div className={classes.Error} onClick={() => setIsValid(true)}>{errorMessage}</div>}
        </div>
    )
}

const InputAmountCurrencyHelper = ({
                                       onChange,
                                       value,
                                       maxValue,
                                       placeholder,
                                       label,
                                       isDisabled,
                                       changeMessage,
                                       blurMessage,
                                       currency
                                   }) => {

    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [isOpened] = useState(false);
    const [currencyList] = useState(currency);

    function handleChange(name, value) {

        if (value.match(/[^0-9.]+/g)) {

            setIsValid(false);

            setErrorMessage(() => {
                return <FormattedMessage id={changeMessage} defaultMessage="no translate"/>
            })

        } else {
            setIsValid(true);

            if (maxValue) {
                if (value > maxValue) {
                    onChange(name, maxValue);
                } else {
                    onChange(name, value);
                }
            } else {
                onChange(name, value);
            }
        }
    }

    function handleBlur(name, value) {
        if (value.length !== 0 && !value.match(/^\d+(\.\d{1,2})?$/)) {

            setIsValid(false);

            setErrorMessage(() => {
                return <FormattedMessage id={blurMessage} defaultMessage="no translate"/>
            })

        } else {
            setIsValid(true);
        }
    }

    return (
        <div className={classes.Wrap}>

            <label className={classes.Label}><FormattedMessage id={label} defaultMessage="no translation"/></label>

            <input placeholder={placeholder}
                   className={classes.Input}
                   value={value}
                   onChange={(e) => handleChange("amount", e.target.value)}
                   onBlur={(e) => handleBlur("amount", e.target.value)}
                   disabled={isDisabled}
            />

            <div className={classes.CurrencySelect}>
                <div className={classes.CurrentCurrency}>
                    {currency[0]}
                    {
                        currencyList.length > 1 && (
                            isOpened ?
                                <Icon className={classes.CurrencySelectIcon} icon="cheveron-up" size={'12px'}/>
                                :
                                <Icon className={classes.CurrencySelectIcon} icon="cheveron-down" size={'12px'}/>
                        )
                    }
                </div>
            </div>

            {!isValid && <div className={classes.Error} onClick={() => setIsValid(true)}>{errorMessage}</div>}
        </div>
    )
}

const CardNumberInputHelper = ({onChange, value, placeholder, isDisabled}) => {

    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    function luhnCheck(pan) {
        if (!pan) return !1;

        if (pan.length % 2 !== 0) pan = "0" + pan;
        let K, Sum = 0;

        for (let i = 0; i < pan.length; i += 2) { K = pan.charAt(i) * 2; Sum += (K > 9 ? K - 9 : K) + Number(pan.charAt(i + 1)); }

        return Sum % 10 === 0;
    }

    function handlerChange(name, value) {
        setIsValid(true);

        if (value.replace(/\s/g, '').length === 16 || value.replace(/\s/g, '').length === 19) {
            if (!luhnCheck(value.replace(/\s/g, ''))) {
                setIsValid(false);
                setErrorMessage(() => {
                    return <FormattedMessage id={'FieldsHelper.error.checkCardNumber'} defaultMessage="no translate"/>
                })
            } else {
                setIsValid(true);
                onChange(name, value);
            }
        }
    }

    function handlerBlur(name, value) {

        if (!luhnCheck(value.replace(/\s/g, ''))) {
            setIsValid(false);
            setErrorMessage(() => {
                return <FormattedMessage id={'FieldsHelper.error.checkCardNumber'} defaultMessage="no translate"/>
            })
        } else {
            setIsValid(true);
            onChange(name, value);
        }
    }

    return (
        <div className={classes.Wrap}>
            <label className={classes.Label}>Номер карты</label>
            <MaskedInput
                className={classes.Input}
                value={value}
                mask={[/\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/, /\d/, " ", /\d/, /\d/, /\d/]}
                placeholderChar={'\u2000'}
                placeholder={placeholder}
                onChange={(e) => handlerChange('pan', e.target.value)}
                onBlur={(e) => handlerBlur('pan', e.target.value)}
                disabled={isDisabled}
                autoComplete="off"
            />
            {!isValid && <div className={classes.Error} onClick={() => setIsValid(true)}>{errorMessage}</div>}
        </div>
    )
}

const PasswordInputHelper = ({onChange, value, isDisabled, label = "Генерация нового пароля"}) => {
    return (
        <div className={classes.Wrap}>
            <div className={classes.InputHeader}>
                <label className={classes.Label}>{label}</label>
                <span className={classes.InputLink} onClick={() => onChange('password', '')}>
                    <Icon className={classes.LinkIcon} icon={"close"} size={"12px"}/>
                    Отменить изменения
                </span>
            </div>
            <input className={classes.Input} placeholder="••••••••••" value={value} readOnly={true}
                   disabled={isDisabled}/>
            <Icon className={classes.IconPassword} icon="key2" size={'22px'} onClick={() => {
                !isDisabled && onChange('password', generator.generate({length: 10, numbers: true, symbols: true}))
            }}/>
        </div>
    )
}


const MultipleField = ({
                           label,
                           name,
                           width,
                           placeholder,
                           fieldName,
                           onChange,
                           changeRegexp,
                           blurRegexp,
                           changeMessage,
                           blurMessage,
                           values,
                           isDisabled,
                           autoComplete
                       }) => {

    const [isValid, setIsValid] = useState(true);
    const [error, setError] = useState({index: 0, message: ""});

    function handleRemove(index) {
        const v = [...values];
        v.splice(index, 1);
        onChange(fieldName, v);
    }

    function handleAdd() {
        const v = [...values];
        v.push("");
        onChange(fieldName, v);
    }

    function handlerChange(index, value) {

        if (changeRegexp && value.match(changeRegexp)) {

            setIsValid(false);

            setError(() => {
                return {index, message: <FormattedMessage id={changeMessage} defaultMessage="no translate"/>}
            })

        } else {
            setIsValid(true);

            const v = [...values];
            v[index] = value;
            onChange(fieldName, v);
        }
    }

    function handlerBlur(index, value) {
        if (blurRegexp && value.length !== 0 && !value.match(blurRegexp)) {

            setIsValid(false);

            setError(() => {
                return {index, message: <FormattedMessage id={blurMessage} defaultMessage="no translate"/>}
            })

        } else {
            setIsValid(true);
        }
    }


    return (
        <div className={classes.Wrap}>
            <label className={classes.Label}><FormattedMessage id={label} defaultMessage="no translation"/></label>

            {values.map((val, index) => {
                return (
                    <div key={index} className={classes.MFFieldWrap}>
                        <input name={name + "_" + index} onChange={(e) => handlerChange(index, e.target.value)}
                               onBlur={(e) => handlerBlur(index, e.target.value)}
                               style={{width: width + "px"}} className={classes.MFField} value={val}
                               placeholder={placeholder} disabled={isDisabled}
                               autoComplete={autoComplete ? autoComplete : "on"}/>
                        {!index ?
                            <Icon onClick={() => handleAdd()} style={{left: width + 10 + "px"}}
                                  className={classes.MFAddIcon} icon="plus" size={'16px'}/>
                            :
                            <Icon onClick={() => handleRemove(index)} style={{left: width + 10 + "px"}}
                                  className={classes.MFRemoveIcon} icon="close" size={'16px'}/>
                        }

                        {!isValid && error.index === index &&
                            <div style={{width: width + "px"}} className={classes.MFFieldError}
                                 onClick={() => setIsValid(true)}>{error.message}</div>}
                    </div>
                )
            })}

        </div>
    )
}


const MultipleSelect = ({
                            label,
                            placeholder,
                            isLoading,
                            selectedValues,
                            values,
                            onChange,
                            excludeSearchColumn
                        }) => {
    const [isOpened, setIsOpened] = useState(false);
    const [searchText, setSearchText] = useState("");

    const wrap = useRef(null);
    const dropdown = useRef(null);

    const safeSelected = selectedValues || [];
    const safeValues = values || [];
    const safeExclude = excludeSearchColumn || [];

    useEffect(() => {
        function handleClickOutside(e) {
            if (wrap.current && !wrap.current.contains(e.target)) {
                setIsOpened(false);
                setSearchText("");
            }
        }

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, []);

    function toggleState() {
        if (isLoading || safeValues.length === 0) return;
        setIsOpened(!isOpened);
        if (!isOpened) setSearchText("");
    }

    function handleChange(uuid, isChecked) {
        onChange(function (prev) {
            var newArr = prev.slice();
            if (isChecked) {
                newArr.push(uuid);
            } else {
                var index = newArr.indexOf(uuid);
                if (index > -1) newArr.splice(index, 1);
            }
            return newArr;
        });
    }

    function isChecked(uuid) {
        return safeSelected.indexOf(uuid) !== -1;
    }

    function renderPlaceholder() {
        if (safeSelected.length === 0) {
            return <FormattedMessage id={placeholder} defaultMessage="no translation"/>;
        }
        if (safeSelected.length > 3) {
            return safeSelected.length + " выбрано";
        }

        var names = [];
        for (var i = 0; i < safeSelected.length; i++) {
            var uuid = safeSelected[i];
            for (var j = 0; j < safeValues.length; j++) {
                if (safeValues[j].uuid === uuid) {
                    names.push(safeValues[j].displayName);
                    break;
                }
            }
        }
        return names.join(", ");
    }

    function getFilteredData() {
        if (!searchText) return safeValues;

        var lower = searchText.toLowerCase();
        var result = [];

        for (var i = 0; i < safeValues.length; i++) {
            var item = safeValues[i];
            var found = false;

            for (var key in item) {
                if (safeExclude.indexOf(key) !== -1) continue;
                var value = item[key];
                if (value === null || value === undefined) continue;
                if (String(value).toLowerCase().indexOf(lower) !== -1) {
                    found = true;
                    break;
                }
            }
            if (found) result.push(item);
        }
        return result;
    }

    var filteredData = getFilteredData();

    return (
        <div ref={wrap} className={classes.Wrap}>
            <label className={classes.Label}>
                <FormattedMessage id={label} defaultMessage="no translation"/>
            </label>

            <div className={classes.SelectWrap}>
                <div
                    className={
                        classes.Select +
                        " " +
                        ((isLoading || safeValues.length === 0) ? classes.SelectDisabled : "")
                    }
                    onClick={toggleState}
                >
                    <span>{renderPlaceholder()}</span>
                    <Icon
                        className={classes.SelectArrow}
                        icon={isLoading ? "lock" : "cheveron-down"}
                        size={isLoading ? "16px" : "18px"}
                    />
                </div>
            </div>

            {isOpened && (
                <div ref={dropdown} className={classes.Dropdown}>
                    {safeValues.length > 10 && (
                        <div className={classes.MultipleSelectSearch}>
                            <input
                                type="text"
                                value={searchText}
                                onChange={function (e) {
                                    setSearchText(e.target.value);
                                }}
                                placeholder="Поиск..."
                            />
                            <Icon
                                className={classes.MultipleSelectSearchIcon}
                                color="#999"
                                icon="search"
                                size="16px"
                            />
                        </div>
                    )}

                    <div className={classes.MultipleSelectList}>
                        {filteredData.length === 0 ? (
                            <div className={classes.MultipleSelectEmpty}>
                                Ничего не найдено
                            </div>
                        ) : (
                            filteredData.map(function (el) {
                                return (
                                    <div key={el.uuid} className={classes.MultipleSelectOption}>
                                        <input
                                            type="checkbox"
                                            id={"option_" + el.uuid}
                                            checked={isChecked(el.uuid)}
                                            onChange={function (e) {
                                                handleChange(el.uuid, e.target.checked);
                                            }}
                                        />
                                        <label
                                            htmlFor={"option_" + el.uuid}
                                            className={classes.MultipleSelectLabel}
                                        >
                      <span className={classes.MultipleSelectSquare}>
                        <Icon
                            icon="checkmark"
                            className={classes.IconCheckmark}
                            color="#FFF"
                            size="13px"
                        />
                      </span>
                                            <span>{el.displayName}</span>
                                        </label>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

const Select = ({
                    label,
                    placeholder,
                    isLoading,
                    selectedValue,
                    values,
                    onChange,
                    onCleanCurrentValue,
                    isClean,
                    isCleanLabel,
                    fieldName,
                    fieldStatus
                }) => {

    const [isOpened, setIsOpened] = useState(false);
    const [data, setData] = useState([]);

    const wrap = useRef(null);
    const dropdown = useRef(null);

    function handleClickOutside(e) {
        if (!dropdown.current || !wrap.current.contains(e.target)) {
            setIsOpened(false);
        }
    }

    function handleSelect(val) {
        setIsOpened(false);
        onChange(val);
    }

    useEffect(() => {
        setData(values);
    }, [values]);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, false);

        return () => {
            window.removeEventListener('click', handleClickOutside);
        };
    }, [handleClickOutside]);

    function toggleState() {
        setIsOpened(!isOpened);
    }

    return (

        <div ref={wrap} className={classes.Wrap}>
            <div className={classes.InputHeader}>
                <label className={classes.Label}>
                    <FormattedMessage id={label} defaultMessage="no translation"/>
                </label>
                {isClean &&
                    <span className={classes.InputLink} onClick={() => onCleanCurrentValue("")}>
                    <Icon className={classes.LinkIcon} icon={"close"} size={"12px"}/>
                        {isCleanLabel ? isCleanLabel : "Отменить изменения"}
                </span>
                }

            </div>

            <div className={classes.SelectWrap}>
                <div className={`${classes.Select} ${isLoading && classes.SelectDisabled}`} onClick={() => {
                    !isLoading && toggleState()
                }}>
                    <span>{selectedValue ? selectedValue[fieldName] :
                        <FormattedMessage id={placeholder} defaultMessage="no translation"/>}</span>
                    <Icon className={classes.SelectArrow} icon={`${isLoading ? "lock" : "cheveron-down"}`}
                          size={`${isLoading ? "16px" : "18px"}`}/>
                </div>
            </div>

            {isOpened &&
                <div ref={dropdown} className={classes.Dropdown}>
                    {data.map((val, i) => {
                        return (fieldStatus !== undefined ? (val[fieldStatus] === 1 || val[fieldStatus] === true) : true) &&
                            <div key={i} onClick={() => handleSelect(val)}
                                 className={classes.Option}>{val[fieldName]}</div>
                    })}
                </div>
            }
        </div>
    )
}

const MaskedIH = ({label, onChange, fieldName, value, placeholder, isDisabled, mask, blurMessage}) => {

    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    function handlerChange(name, value) {
        onChange(name, value);
    }

    function handlerBlur(name, value) {
        if (value.length === 0) {
            setIsValid(false);
            setErrorMessage(() => {
                return <FormattedMessage id={blurMessage} defaultMessage="no translate"/>
            })
        } else {
            setIsValid(true);
            onChange(name, value);
        }
    }

    return (
        <div className={classes.Wrap}>
            <label className={classes.Label}>
                <FormattedMessage id={label} defaultMessage="no translation"/>
            </label>

            <MaskedInput
                className={classes.Input}
                value={value}
                mask={mask}
                placeholderChar={'\u2000'}
                placeholder={placeholder}
                onChange={(e) => handlerChange(fieldName, e.target.value)}
                onBlur={(e) => handlerBlur(fieldName, e.target.value)}
                disabled={isDisabled}
                autoComplete="off"
            />
            {!isValid && <div className={classes.Error} onClick={() => setIsValid(true)}>{errorMessage}</div>}
        </div>
    )
}

function AddressDaData({
                           label,
                           fieldName,
                           placeholder,
                           value,
                           isDisabled,
                           readonly,
                           onChange,
                           changeRegexp,
                           changeMessage
                       }) {

    const [searchTerm, setSearchTerm] = useState("");
    const [results, setResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isOpened, setIsOpened] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');

    const debouncedSearchTerm = useDebounce(searchTerm, 600);

    const wrap = useRef(null);
    const dropdown = useRef(null);
    const input = useRef(null);

    function handleClickOutside(e) {
        if (!dropdown.current || !wrap.current.contains(e.target)) {
            setIsOpened(false);
        }
    }

    useEffect(() => {
        if (value) {
            setSearchTerm(value);
        }
    }, [value])

    useEffect(() => {

        if (debouncedSearchTerm.length > 4) {
            setIsSearching(true);

            searchSuggestions(debouncedSearchTerm).then(results => {
                setIsSearching(false);
                input.current.focus();
                setResults(results.suggestions);

                if (results.suggestions.length)
                    setIsOpened(true);
            })
        } else {
            setResults([]);
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, false);

        return () => {
            window.removeEventListener('click', handleClickOutside);
        };
    }, [handleClickOutside]);


    const handlerChange = (value) => {
        if (changeRegexp && value.match(changeRegexp)) {

            setIsValid(false);

            setErrorMessage(() => {
                return <FormattedMessage id={changeMessage} defaultMessage="no translate"/>
            })

        } else {
            setIsValid(true);
            setSearchTerm(value);
        }
    }

    const handlerBlur = () => {

        if (results.length === 1) {
            onChange(fieldName, results[0]);
        }
    }

    const handleSelect = (id) => {
        onChange(fieldName, results[id]);
        setSearchTerm(results[id].value);
    }

    function searchSuggestions(query) {
        const url = "https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address";
        const token = "304d96ec0d8e1b4415ccc071d59e727e90d52282";

        const options = {
            method: "POST",
            mode: "cors",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Token " + token
            },
            body: JSON.stringify({query: query})
        }

        return fetch(url, options)
            .then(r => r.json())
            .then(r => r)
            .catch(error => {
                    Sentry.captureException(error);
                    console.error("error", error);
                    return [];
                }
            );
    }

    return (
        <div ref={wrap} className={classes.Wrap}>
            <label className={classes.Label}>
                <FormattedMessage id={label} defaultMessage="no translation"/>
            </label>

            <input placeholder={placeholder}
                   className={classes.Input}
                   value={searchTerm}
                   onChange={(e) => handlerChange(e.target.value)}
                   onBlur={(e) => handlerBlur(fieldName, e.target.value)}
                   disabled={isDisabled || isSearching}
                   autoComplete={"off-" + Math.random()}
                   readOnly={readonly}
                   ref={input}
            />

            {isOpened &&
                <div ref={dropdown} className={classes.Dropdown}>
                    {results.map((el, i) => {
                        return <div key={i} onClick={() => handleSelect(i)}
                                    className={classes.DropdownItem}>{el.value}</div>
                    })}
                </div>
            }

            {!isValid && <div className={classes.Error} onClick={() => setIsValid(true)}>{errorMessage}</div>}
        </div>
    )
}

InputAmountCurrencyHelper.propTypes = {
    currency: PropTypes.array.isRequired
}

export {
    InputHelper,
    CardNumberInputHelper,
    PasswordInputHelper,
    InputAmountCurrencyHelper,
    MultipleField,
    MultipleSelect,
    Select,
    MaskedIH,
    AddressDaData
};


// WEBPACK FOOTER //
// ./src/Components/Utils/FieldsHelper/index.js